/* ============================================================
   v166 — sheets made in the retired Drip Apps builder (their line properties point at
   dripappsserver.com) can't be checked out while Theme settings → Gang sheet builder is
   "WSV". The cart page is drawn by Liquid (snippets/wsv-line-extras.liquid,
   sections/main-cart.liquid); the drawer is re-drawn by theme.js after every change, so this
   re-applies the note on those lines, hides their links back into the old builder, and turns
   the checkout buttons off until they're removed. Set the theme setting back to "Drip" and
   this does nothing (the rollback if the WSV builders ever need to step aside).

   v176 (2026-09-29) — order #92046: a sheet built in Drip on Sep 24 sat in a cart until Sep 29
   and was checked out from a cart tab drawn BEFORE v166 existed — a disabled button can't reach
   a page that is already open. So an old-builder line is now TAKEN OUT of the cart (/cart/change
   with quantity 0) the moment any page of the store is drawn — the cart is one cart on the
   server, so the stale tab's checkout then has nothing to sell — and the customer is told what
   happened and where to rebuild. Owner: "i dont want any more drip orders going through".
   A gang-sheet line with no design at all (`_gs_design_id` missing — a re-order button, an old
   link) can't be printed either: it keeps the checkout off with a note, but stays in the cart.
   ============================================================ */
(function () {
  'use strict';
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer || drawer.getAttribute('data-gs-builder') !== 'wsv') return;
  var OLD = /dripappsserver\.com/i;
  var FLAG = 'wsv_old_removed';

  function isOld(item) {
    var p = item.properties || {};
    for (var k in p) {
      if (Object.prototype.hasOwnProperty.call(p, k) && typeof p[k] === 'string' && OLD.test(p[k])) return true;
    }
    return false;
  }
  function isSheet(item) {
    return item.product_type === 'Gang Sheet' || /gang\s*sheet/i.test(item.product_title || item.title || '');
  }
  // a gang-sheet product with no design on it: nothing was built, nothing can print
  function isBare(item) {
    var p = item.properties || {};
    return isSheet(item) && !isOld(item) && !(typeof p._gs_design_id === 'string' && p._gs_design_id);
  }
  function builderFor(item) {
    var h = item.handle || '';
    if (h.indexOf('uv-dtf') !== -1) return '/apps/uv-gang-sheet';
    if (h.indexOf('sublimation') !== -1) return '/apps/sub-gang-sheet';
    return '/apps/gang-sheet';
  }
  var CART_URL = (window.WSV && window.WSV.routes && window.WSV.routes.cart) || '/cart';
  var CART = CART_URL + '.js';
  var CHANGE = CART_URL + '/change.js';
  function note(href, bare) {
    var d = document.createElement('div');
    d.className = 'li-old';
    d.setAttribute('role', 'alert');
    d.innerHTML = bare
      ? '<strong>No design on this sheet.</strong> It was added without the builder (a re-order button or an old link), so there is nothing to print. Remove it and build your sheet in the <a href="' + href + '">Gang Sheet Builder</a>.'
      : '<strong>Made in our old gang sheet builder.</strong> That builder is retired, so this sheet can’t be checked out. Remove it and rebuild it in the new <a href="' + href + '">Gang Sheet Builder</a> — same sizes and prices.';
    return d;
  }
  function removedCount() {
    try { return parseInt(sessionStorage.getItem(FLAG) || '0', 10) || 0; } catch (e) { return 0; }
  }
  function removedText(n) {
    return '<strong>' + (n === 1 ? 'A sheet made in our old gang sheet builder was removed from your cart.' : n + ' sheets made in our old gang sheet builder were removed from your cart.') +
      '</strong> That builder is retired and its sheets can’t be printed. Rebuild ' + (n === 1 ? 'it' : 'them') + ' in the new <a href="/apps/gang-sheet">Gang Sheet Builder</a> — same sizes and prices.';
  }
  // the "removed" notice: the drawer's note line, and a banner at the top of the cart page (empty cart included)
  function showRemoved(n) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-oldbuilder-note]'), function (el) {
      el.innerHTML = removedText(n);
      el.removeAttribute('hidden');
    });
    var page = document.querySelector('.cart-page .page-width');
    if (page && !page.querySelector('[data-oldbuilder-removed]')) {
      var b = document.createElement('div');
      b.className = 'wsv-oldbuilder';
      b.setAttribute('role', 'alert');
      b.setAttribute('data-oldbuilder-removed', '');
      b.innerHTML = removedText(n);
      var h1 = page.querySelector('.cart-page__title');
      if (h1 && h1.nextSibling) page.insertBefore(b, h1.nextSibling); else page.appendChild(b);
    }
  }
  // take the old-builder lines out, one at a time (each /cart/change is a whole-cart write)
  function removeAll(keys) {
    var i = 0;
    function next() {
      if (i >= keys.length) return Promise.resolve();
      var key = keys[i++];
      return fetch(CHANGE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function (r) { if (!r.ok) throw new Error('change ' + r.status); }).then(next);
    }
    return next();
  }

  var busy = false, again = false;
  function apply() {
    if (busy) { again = true; return; }
    busy = true;
    fetch(CART, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var old = {}, bare = {}, oldKeys = [];
        var nOld = 0, nBare = 0;
        (cart.items || []).forEach(function (it) {
          if (isOld(it)) { old[it.key] = builderFor(it); oldKeys.push(it.key); nOld++; }
          else if (isBare(it)) { bare[it.key] = builderFor(it); nBare++; }
        });
        var n = nOld + nBare;
        Array.prototype.forEach.call(document.querySelectorAll('[data-cart-item]'), function (row) {
          var key = row.getAttribute('data-key');
          var href = old[key] || bare[key];
          if (!href) return;
          // the old builder's Preview / Edit links lead straight back into it
          Array.prototype.forEach.call(row.querySelectorAll('.li-props li'), function (li) {
            if (OLD.test(li.textContent)) li.style.display = 'none';
          });
          if (row.querySelector('.li-old')) return;
          var anchor = row.querySelector('.li-props') || row.querySelector('.cart-item__variant') || row.querySelector('.cart-table__variant') || row.querySelector('.cart-item__title') || row.querySelector('.cart-table__name');
          if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(note(href, !!bare[key]), anchor.nextSibling);
        });
        Array.prototype.forEach.call(document.querySelectorAll('button[name="checkout"]'), function (b) {
          if (!b.getAttribute('data-checkout-label')) b.setAttribute('data-checkout-label', b.textContent);
          b.disabled = n > 0;
          if (n > 0) { b.setAttribute('aria-disabled', 'true'); b.textContent = nOld > 0 ? 'Remove the old-builder sheet to check out' : 'Remove the sheet with no design to check out'; }
          else { b.removeAttribute('aria-disabled'); b.textContent = b.getAttribute('data-checkout-label'); }
        });
        var removed = removedCount();
        Array.prototype.forEach.call(document.querySelectorAll('[data-oldbuilder-note]'), function (el) {
          if (n > 0) {
            var why = nOld > 0
              ? 'A sheet made in our old gang sheet builder is in your cart — remove it (and rebuild it in the new builder) to check out.'
              : 'A gang sheet in your cart has no design on it — remove it and build your sheet in the Gang Sheet Builder to check out.';
            // (both at once: what was already taken out this visit, then what still blocks the checkout)
            if (removed > 0 && nOld === 0) el.innerHTML = removedText(removed) + ' ' + why; else el.textContent = why;
            el.removeAttribute('hidden');
          } else if (removed > 0) {
            el.innerHTML = removedText(removed);
            el.removeAttribute('hidden');
          } else {
            el.setAttribute('hidden', '');
          }
        });
        if (removed > 0 && nOld === 0) showRemoved(removed);
        // v176 — the old-builder lines come out of the cart here
        if (oldKeys.length) {
          return removeAll(oldKeys).then(function () {
            try { sessionStorage.setItem(FLAG, String(removed + oldKeys.length)); } catch (e) { /* no storage: the cart is right anyway */ }
            var onCart = /^\/cart(\/|$|\?)/.test(location.pathname + location.search) || location.pathname === CART_URL;
            var open = !drawer.hasAttribute('hidden');
            if (onCart || open) { location.reload(); return; }
            // browsing elsewhere: the badge catches up on the next page; the drawer says so when opened
            showRemoved(removed + oldKeys.length);
          });
        }
      })
      .catch(function () { /* the Liquid-drawn state stands (the checkout button stays off) */ })
      .then(function () { busy = false; if (again) { again = false; apply(); } });
  }

  apply();
  var body = drawer.querySelector('[data-cart-body]');
  if (body && 'MutationObserver' in window) {
    // theme.js swaps the drawer's list wholesale (innerHTML) after every change
    new MutationObserver(function () { setTimeout(apply, 60); }).observe(body, { childList: true });
  }
})();
